import { useState, useEffect } from 'react';

export function useStableValue(value, freeze) {
  const [stable, setStable] = useState(value);

  useEffect(() => {
    if (!freeze) {
      setStable(value);
    }
  }, [value, freeze]);

  return stable;
}
